<template>
  <v-card
    class="interview-format-card"
    :class="{ selected: isSelected }"
    @click="handleClick"
  >
    <v-card-title class="d-flex justify-space-between align-center">
      <div class="d-flex">
        <v-radio-group class="basic-radio-button" :value="radioValue">
          <v-radio value="enabled" />
        </v-radio-group>
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2" large>
            mdi-clipboard-text-outline
          </v-icon>
          <div clas="d-flex flex-column">
            <h3>{{ interviewFormat.interviewName | capitalize }}</h3>
            <span class="secondary-text">
              {{ interviewFormat.duration }}
              {{ pluralize("minutes", interviewFormat.duration) }}
            </span>
          </div>
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <InterviewFormatBasicInfo :interviewFormat="interviewFormat" />
    </v-card-text>
  </v-card>
</template>

<script>
import pluralize from "pluralize";
import InterviewFormatBasicInfo from "@/views/bookings/BookingInterviews/components/InterviewFormatBasicInfo";

export default {
  props: {
    interviewFormat: {
      type: Object,
      required: true
    },
    isSelected: Boolean
  },
  components: {
    InterviewFormatBasicInfo
  },
  computed: {
    radioValue() {
      return this.isSelected ? "enabled" : "disabled";
    }
  },
  methods: {
    handleClick() {
      this.$emit("onSelect", this.interviewFormat);
    },
    openEditDialog() {
      this.isEditDialogOpen = true;
    },
    pluralize
  }
};
</script>

<style lang="scss">
.interview-format-card.v-sheet.theme--light {
  border: 1px solid $secondary-line;
  border-radius: 4px;
  padding: 15px;

  .v-card__title {
    padding: 0px;
  }

  .v-card__text {
    padding: 0px;
  }

  .v-radio {
    margin-right: 5px;
    margin-top: 1px;
  }

  .v-application .accent--text {
    color: $selected;
  }

  &.selected {
    border: 2px solid $river-bed;
  }
}

.interview-format-card.v-sheet.theme--light.selected {
  border: 1px solid $selected;
  box-shadow: 0 0 0 1px $selected;
}
</style>
